import React, { useState, useEffect, useRef } from 'react';
import './HowItWorks.css';

const BRAND_GRAD = 'linear-gradient(90deg,#6366F1,#8B5CF6 55%,#D946EF)';

const STAGES = [
  { icon: 'bx-file',        n: '1', title: 'Document In',         caption: 'Scanned report, any format.' },
  { icon: 'bx-scan',        n: '2', title: 'Oculo Extraction',    caption: 'Field-level extraction at 99.5%+ accuracy.' },
  { icon: 'bx-copy-alt',    n: '3', title: 'Digital Twin',        caption: 'Verify in the document you already know.' },
  { icon: 'bx-data',        n: '4', title: 'Structured Database', caption: 'Every field stored, searchable, traceable.' },
  { icon: 'bx-trending-up', n: '5', title: 'Output',              caption: 'Generate analytics. Export to client systems.' },
];

function HowItWorks() {
  const [stagesLit, setStagesLit] = useState(false);
  const diagramRef = useRef(null);

  useEffect(() => {
    const stageObs = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { setStagesLit(true); stageObs.unobserve(entry.target); }
      });
    }, { threshold: 0.3 });
    if (diagramRef.current) stageObs.observe(diagramRef.current);
    return () => stageObs.disconnect();
  }, []);

  return (
    <section style={{ background: '#131022', padding: '104px 56px' }}>
      <div style={{ maxWidth: 1240, margin: '0 auto' }}>
        <div className="oc-reveal" style={{ textAlign: 'center', marginBottom: 56 }}>
          <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>HOW IT WORKS</span>
          <h2 style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 38, letterSpacing: '-0.015em', color: '#fff' }}>From scanned report to structured record</h2>
        </div>
        <div ref={diagramRef} style={{ position: 'relative', padding: '8px 4px' }}>
          <div className="oc-hide-sm" style={{ position: 'absolute', left: '7%', right: '7%', top: 44, height: 2, borderRadius: 2, background: 'linear-gradient(90deg, rgba(129,107,255,0.0), rgba(129,107,255,0.16) 14%, rgba(139,92,246,0.16) 50%, rgba(217,70,239,0.16) 86%, rgba(217,70,239,0))' }} />
          <div className={'oc-track-fill oc-hide-sm' + (stagesLit ? ' oc-filled' : '')} />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 18, position: 'relative' }} className="oc-grid-5">
            {STAGES.map((s, i) => (
              <div key={s.n} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <div className={'oc-stage' + (stagesLit ? ' oc-lit' : '')} style={{ transitionDelay: stagesLit ? (i * 250) + 'ms' : '0ms' }}>
                  <i className={'bx ' + s.icon} style={{ fontSize: 34, background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }} />
                  <span className="oc-stage-badge">{s.n}</span>
                </div>
                <span style={{ marginTop: 18, font: '800 16px Manrope,sans-serif', color: '#fff' }}>{s.title}</span>
                <span style={{ marginTop: 8, font: '500 13px Manrope,sans-serif', lineHeight: 1.5, color: 'rgba(255,255,255,0.55)', maxWidth: 180 }}>{s.caption}</span>
              </div>
            ))}
          </div>
        </div>
        <p className="oc-reveal oc-hide-sm" style={{ margin: '48px auto 0', maxWidth: 760, textAlign: 'center', fontFamily: 'Montserrat,sans-serif', fontSize: 16, lineHeight: 1.6, color: 'rgba(255,255,255,0.55)' }}>
          Every report becomes a precise digital twin. Structured, searchable, and ready to put to work.
        </p>
      </div>
    </section>
  );
}

export default HowItWorks;
